import { dataFilter } from './helper';
import { LOGOUT, LOGIN_SUCCESS, LOAD_USER_PROFILE, CREATE_APP_SUCCESS, RESET_PASSWORD_SUCCESS, CREATE_APP_TEMPLATE_SUCCESS, DELETE_APP_TEMPLATES_SUCCESS, } from '../../containers/Root/constants';
import { CREATE_EDGE_SUCCESS, DELETE_EDGE_SUCCESS, CREATE_PATCH_SUCCESS, DELETE_PATCH_SUCCESS, } from '../../containers/StructureBuilderPage/constants';
import { ADD_USER_SUCCESS } from '../userImportNew/constants';
import { CREATE_VIEW_SUCCESS } from '../../containers/ViewNew/constants';
import { CREATE_STYLE_SUCCESS } from '../../containers/StyleNew/constants';
import { INVITE_USER_SUCCESS } from '../../store/userInvite/constants';
import { ADD_VERSION_SUCCESS } from '../../store/versionNew/constants';
import { pushToDataLayer } from '../../containers/Root/AnalyticsBar/helpers';
import { USER_NAME_UPDATE_SUCCESS } from '../../store/appUserEdit/constants';
export var extraDataLayer = function () {
    return function (next) {
        return function (action) {
            var _a;
            var eventName = '';
            var dataLayerValues = {};
            switch (action.type) {
                case LOGIN_SUCCESS:
                    eventName = 'login_success';
                    break;
                case LOAD_USER_PROFILE:
                    var profileItems = action === null || action === void 0 ? void 0 : action.me;
                    var profileFilterData = [
                        'id',
                        'created_at',
                        'email_verified',
                        'email_verified_at',
                        'invited',
                        'type',
                    ];
                    dataLayerValues = dataFilter(profileItems, profileFilterData);
                    if (!dataLayerValues['email_verified']) {
                        dataLayerValues['email_verified_at'] = null;
                    }
                    eventName = 'load_user_profile';
                    break;
                case LOGOUT:
                    eventName = 'logout_success';
                    break;
                case CREATE_APP_SUCCESS:
                    var appItems = action === null || action === void 0 ? void 0 : action.app;
                    var appFilterData = ['id', 'name', 'owner', 'platform_version'];
                    dataLayerValues = dataFilter(appItems, appFilterData);
                    eventName = 'app_created_success';
                    break;
                case CREATE_PATCH_SUCCESS:
                    var patchItems = action === null || action === void 0 ? void 0 : action.patch;
                    var patchFilterData = ['id', 'patchwork', 'name', 'type'];
                    dataLayerValues = dataFilter(patchItems, patchFilterData);
                    eventName = 'patch_created_success';
                    break;
                case DELETE_PATCH_SUCCESS:
                    eventName = 'patch_deleted_success';
                    break;
                case CREATE_VIEW_SUCCESS:
                    var viewItems = action === null || action === void 0 ? void 0 : action.view;
                    var viewFilterData = ['version', 'type', 'name', 'app', 'id'];
                    dataLayerValues = dataFilter(viewItems, viewFilterData);
                    eventName = 'view_created_success';
                    break;
                case CREATE_EDGE_SUCCESS:
                    var edgeItems = action === null || action === void 0 ? void 0 : action.edge;
                    var edgeFilterData = [
                        'id',
                        'to_arg',
                        'from_arg',
                        'to_patch',
                        'patchwork',
                        'from_patch',
                    ];
                    dataLayerValues = dataFilter(edgeItems, edgeFilterData);
                    eventName = 'edge_created_success';
                    break;
                case DELETE_EDGE_SUCCESS:
                    eventName = 'edge_deleted_success';
                    break;
                case 'CREATE_STATE_SUCCESS':
                    var stateItems = action === null || action === void 0 ? void 0 : action.states[0];
                    var stateFilterData = ['id', 'app', 'type', 'label'];
                    dataLayerValues = dataFilter(stateItems, stateFilterData);
                    eventName = 'state_created_success';
                    break;
                case 'CREATE_VARIABLE_SUCCESS':
                    var variableItems = action === null || action === void 0 ? void 0 : action.variables[0];
                    var variableFilterData = ['id', 'app', 'type', 'label'];
                    dataLayerValues = dataFilter(variableItems, variableFilterData);
                    eventName = 'variables_created_success';
                    break;
                case 'CREATE_STORAGE_ITEM_SUCCESS':
                    var storageItems = action === null || action === void 0 ? void 0 : action.storage[0];
                    var storageFilterData = ['id', 'app', 'type', 'label'];
                    dataLayerValues = dataFilter(storageItems, storageFilterData);
                    eventName = 'storage_item_created_success';
                    break;
                case CREATE_STYLE_SUCCESS:
                    var styleItems = action === null || action === void 0 ? void 0 : action.style;
                    var styleFilterData = ['id', 'app', 'description', 'name'];
                    dataLayerValues = dataFilter(styleItems, styleFilterData);
                    eventName = 'style_created_success';
                    break;
                case 'CREATE_LANGUAGE_SUCCESS':
                    var languageItems = action === null || action === void 0 ? void 0 : action.language;
                    var languageFilterData = ['id', 'app', 'label'];
                    dataLayerValues = dataFilter(languageItems, languageFilterData);
                    eventName = 'language_created_success';
                    break;
                case 'CREATE_TRANSLATION_SUCCESS':
                    var translationPosition = (action === null || action === void 0 ? void 0 : action.translations.length) - 1;
                    var translationItems = (_a = action === null || action === void 0 ? void 0 : action.translations[translationPosition]) === null || _a === void 0 ? void 0 : _a.languages[0];
                    var translationFilterData = ['id', 'app', 'label', 'value'];
                    dataLayerValues = dataFilter(translationItems, translationFilterData);
                    eventName = 'translations_created_success';
                    break;
                case ADD_VERSION_SUCCESS:
                    eventName = 'version_create_success';
                    break;
                case 'AppSettings/CLONE_SUCCESS':
                    eventName = 'app_clone_success';
                    break;
                case 'AppSettings/CLONE_IN_CLONE_AND_UPDATE_SUCCESS':
                    eventName = 'app_update_and_clone_success';
                    break;
                case 'AppSettings/DELETE_SUCCESS':
                    eventName = 'app_data_delete_success';
                    break;
                case 'AppSettings/CLEAR_APP_DATA_SUCCESS':
                    eventName = 'app_data_clear_success';
                    break;
                case CREATE_APP_TEMPLATE_SUCCESS:
                    var appTempItems = action === null || action === void 0 ? void 0 : action.newTemplate;
                    var appTempFilterData = ['id', 'app', 'owner', 'global'];
                    dataLayerValues = dataFilter(appTempItems, appTempFilterData);
                    eventName = 'app_template_create_success';
                    break;
                case DELETE_APP_TEMPLATES_SUCCESS:
                    dataLayerValues = { id: action === null || action === void 0 ? void 0 : action.templateId };
                    eventName = 'app_template_delete_success';
                    break;
                case ADD_USER_SUCCESS:
                    var userItems = action === null || action === void 0 ? void 0 : action.createdUsers[0];
                    var userFilterData = ['id', 'app', 'type'];
                    dataLayerValues = dataFilter(userItems, userFilterData);
                    eventName = 'user_add_success';
                    break;
                case INVITE_USER_SUCCESS:
                    eventName = 'user_invite_success';
                    break;
                case USER_NAME_UPDATE_SUCCESS:
                    eventName = 'user_edit_success';
                    break;
                case RESET_PASSWORD_SUCCESS:
                    eventName = 'user_reset_password_success';
                    break;
                case 'CANCEL_DEV_PLAN_SUCCESS':
                    eventName = 'dev_plan_cancel_success';
                    break;
                case 'REACTIVATE_DEV_PLAN_SUCCESS':
                    eventName = 'dev_plan_reactivate_success';
                    break;
                case 'SET_BUNDLE_QUANTITY_SUCCESS':
                    eventName = 'set_bundle_quantity_success';
                    break;
                case 'PURCHASE_ORG_DEVELOPER_PLAN_SUCCESS':
                    var orgDevItems = action === null || action === void 0 ? void 0 : action.developerPlan;
                    var orgDevData = [
                        'id',
                        'type',
                        'name',
                        'interval',
                        'currency',
                        'description',
                        'trial_period',
                    ];
                    dataLayerValues = dataFilter(orgDevItems, orgDevData);
                    eventName = 'org_dev_plan_purchase_success';
                    break;
                case 'PURCHASE_DEV_PLAN_BUNDLES_SUCCESS':
                    var orgDevBundleItems = action === null || action === void 0 ? void 0 : action.developerPlan;
                    var orgDevBundleData = [
                        'id',
                        'type',
                        'name',
                        'interval',
                        'currency',
                        'description',
                        'trial_period',
                    ];
                    dataLayerValues = dataFilter(orgDevBundleItems, orgDevBundleData);
                    eventName = 'org_dev_plan_bundle_purchase_success';
                    break;
                default:
                    break;
            }
            if (eventName !== '') {
                pushToDataLayer('apt', 'cms', eventName, dataLayerValues);
            }
            return next(action);
        };
    };
};
